import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

const DevelopersOutlined = ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }: BusinessIconImageProps) =>
  h(
    'svg',
    {
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      color,
      "stroke-width": strokeWidth,
      style,
      ...props,
    },
    [
      h(
        'path',
        {
          d: 'M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5Z',
          stroke: 'currentColor',
          "stroke-width": strokeWidth ?? "1.41667",
          "stroke-linecap": 'round',
          "stroke-linejoin": 'round',
        },
      ),
      h(
        'path',
        {
          d: 'M8.76997 14.5088L6.43652 12.1754L8.76997 9.84192',
          stroke: 'currentColor',
          "stroke-width": strokeWidth ?? "1.41667",
          "stroke-linecap": 'round',
          "stroke-linejoin": 'round',
        },
      ),
      h(
        'path',
        {
          d: 'M15.2305 14.5088L17.564 12.1754L15.2305 9.84192',
          stroke: 'currentColor',
          "stroke-width": strokeWidth ?? "1.41667",
          "stroke-linecap": 'round',
          "stroke-linejoin": 'round',
        },
      ),
      h(
        'path',
        {
          d: 'M12.7751 8.77075L11.2251 15.2292',
          stroke: 'currentColor',
          "stroke-width": strokeWidth ?? "1.41667",
          "stroke-linecap": 'round',
          "stroke-linejoin": 'round',
        },
      ),
    ],
  );

export default DevelopersOutlined;
